/* eslint-disable prettier/prettier */
import { useState } from 'react';
import { assessmentSubmissionService } from '../services/assessmentSubmission.service';

export function useDeleteAssessmentSubmission() {
	const [deleting, setDeleting] = useState(false);
	const [error, setError] = useState<string | null>(null);

	const deleteSubmission = async (
		submissionId: string,
		onSuccess?: () => void
	) => {
		try {
			setDeleting(true);
			setError(null);

			await assessmentSubmissionService.deleteSubmission(submissionId);

			onSuccess?.();
		} catch (err: any) {
			setError(err.message || 'Delete failed');
			throw err;
		} finally {
			setDeleting(false);
		}
	};

	return {
		deleteSubmission,
		deleting,
		error,
	};
}
